import React from "react";
import { NavLink } from "react-router-dom";

const SidebarAdmin = () => {
  return (
    <ul className="sidebar-nav">
      {/* Dashboard */}
      <li className="sidebar-item">
        <NavLink
          to="/heropro/dashboard"
          className="sidebar-link"
          activeClassName="active"
        >
          <i className="fas fa-tachometer-alt"></i> Dashboard
        </NavLink>
      </li>

      {/* Gestión de Inventario */}
      <li className="sidebar-item">
        <NavLink
          to="/heropro/inventario"
          className="sidebar-link"
          activeClassName="active"
        >
          <i className="fas fa-box"></i> Gestión de Inventario
        </NavLink>
      </li>

      {/* Materiales Reciclados */}
      <li className="sidebar-item">
        <NavLink
          to="/heropro/materiales"
          className="sidebar-link"
          activeClassName="active"
        >
          <i className="fas fa-recycle"></i> Materiales Reciclados
        </NavLink>
      </li>

      {/* Proveedores */}
      <li className="sidebar-item">
        <NavLink
          to="/heropro/recicladores"
          className="sidebar-link"
          activeClassName="active"
        >
          <i className="fas fa-truck"></i> Proveedores
        </NavLink>
      </li>
    </ul>
  );
};

export default SidebarAdmin;
